import paymentsInvoicePreviewComponent from './payments-invoice-preview.component';

const paymentsInvoicePreviewModule = angular.module('paymentsInvoicePreview', [
])
  .component('paymentsInvoicePreview', paymentsInvoicePreviewComponent)
  .name;

export default paymentsInvoicePreviewModule;
